import domContentLoaded from 'dom-content-loaded';

export default () => {
	window.addEventListener('load', () => {
		const { body } = document;
		body.classList.remove('js_loading');
		body.classList.add('js_loaded');
	});
	domContentLoaded(() => {
		const loadingObj = document.querySelector('.js_loadingObj');
		loadingObj.addEventListener('transitionend', (e) => {
			e.target.style.display = 'none';
		});
		loadingObj.addEventListener('webkitTransitionEnd', (e) => {
			e.target.style.display = 'none';
		});
	});
};
